export enum Routes {
  BOARD = '/board'
}
